// extracted by mini-css-extract-plugin
export var container = "_fx-0";
export var outlet = "_fx-1";
export var outletEnter = "_fx-2";
export var outletEnterActive = "_fx-3";
export var outletExit = "_fx-4";
export var outletExitActive = "_fx-5";